import React, { useState } from "react";
import {
  Box,
  TextField,
  FormControl,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import { addPackageAction } from "../../redux/actions/packageAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingIndicator from "../../components/loadingIndicator";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  basePrice: yup.string().required("BasePrice is required"),
  isActive: yup.string().required("Select a status"),
});

const CreatePackage = () => {
  const initialFormState = {
    title: "",
    basePrice: "",
    isActive: "",
  };
  const [formData, setFormData] = useState(initialFormState);

  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true); // Start loading
      await validationSchema.validate(
        { ...formData, table: formData.table },
        { abortEarly: false }
      );

      const updatedFormData = {
        ...formData,
      };

      const response = await dispatch(addPackageAction(updatedFormData));
      console.log("Data submitted:", response.data);
      if (response) {
        toast.success("Package added successfully");
        navigate("/package");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to add package");
      }
      setErr({});
    } catch (error) {
      console.error("Error submitting data:", error);
      // Handle validation errors
      if (error.inner) {
        const errors = {};
        error.inner.forEach((validationError) => {
          errors[validationError.path] = validationError.message;
        });
        setErr(errors);
      }
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="ADD PACKAGE" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            value={formData.title}
            onBlur={handleBlur}
            onChange={handleChange}
            margin="normal"
          />{" "}
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}{" "}
          {/* BASEPRICE */}
          <TextField
            label="Base Price"
            name="basePrice"
            value={formData.basePrice}
            onBlur={handleBlur}
            onChange={handleChange}
            type="number"
            margin="normal"
          />{" "}
          {err.basePrice && (
            <Grid item>
              <Typography color="error">{err.basePrice}</Typography>
            </Grid>
          )}{" "}
          {/* IS ACTIVE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Is Active</InputLabel>
            <Select
              name="isActive"
              value={formData.isActive}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              {/* <MenuItem value="">
                <em>Select</em>
              </MenuItem> */}
              <MenuItem value="true">True</MenuItem>
              <MenuItem value="false">False</MenuItem>
            </Select>{" "}
            {err.isActive && (
              <Grid item>
                <Typography color="error">{err.isActive}</Typography>
              </Grid>
            )}{" "}
          </FormControl>
          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              disabled={loading}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
      {loading && <LoadingIndicator />}
    </Box>
  );
};

export default CreatePackage;
